import { Navigate, Outlet } from 'react-router-dom'
import React, { useEffect } from 'react'
import { Skeleton, useTheme } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { StoreStatus, Role } from 'common/utils/types'
import { initializeVendor } from 'features/vendor/vendor.service'
import { getUserInfo } from 'common/authentication/auth.service'
import { UserRoles } from 'utils/types'

import { getMainAppForRole } from '../../utils/functions'

const acceptedRoles = [
  Role.vendor,
  Role.consultant,
  Role.company,
  Role.admin,
  UserRoles.Admin,
  UserRoles.Vendor,
]

export const RequireVendorAuth = (): React.ReactElement => {
  const dispatch = useAppDispatch()
  const { palette } = useTheme()
  const { roles, isAuthenticated, spoofSessionToken, navigateTo, userInfo } = useAppSelector(
    (state) => state.auth,
  )
  const { vendorInitializationStatus } = useAppSelector((state) => state.vendor)

  useEffect(() => {
    if (!userInfo && isAuthenticated) {
      void dispatch(getUserInfo(true))
    }
  }, [userInfo])

  useEffect(() => {
    if (roles && !roles.some((role) => acceptedRoles.includes(role))) {
      window.location.replace(`${window.location.origin}${getMainAppForRole(roles[0])}`)
    } else if (
      roles &&
      (!roles.some((role) => role === Role.admin) ||
        (spoofSessionToken && roles.some((role) => role === Role.admin)))
    ) {
      void dispatch(initializeVendor())
    }
  }, [])

  if (!isAuthenticated) {
    return <Navigate to={{ pathname: navigateTo || '/auth' }} replace />
  }

  if (roles?.includes(Role.admin) && !spoofSessionToken) {
    return <Outlet />
  }

  if (
    vendorInitializationStatus === StoreStatus.Succeeded ||
    vendorInitializationStatus === StoreStatus.Failed
  ) {
    return <Outlet />
  }

  return (
    <>
      <Skeleton
        height="73px"
        width="100vw"
        variant="rectangular"
        sx={{ backgroundColor: palette.blue500.main }}
      />
      <Skeleton
        height="calc(100vh - 73px)"
        width="100vw"
        variant="rectangular"
        sx={{ backgroundColor: palette.blue800.main }}
      />
    </>
  )
}

export const RedirectIfAuth = (): React.ReactElement => {
  const { isAuthenticated } = useAppSelector((state) => state.auth)

  if (isAuthenticated) {
    return <Navigate to={{ pathname: '/' }} replace />
  }

  return <Outlet />
}
